import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import DoctorInformation from "./doctor"
import { errorToast, successToast } from "../../../components/toastmessage/toastmessage"
import axios from "axios"

const DoctorContainer = () => {
  // 
  const submitDoctorInfo = (event, doctorInfo) => {
    event.preventDefault();
    let body = {
      ...doctorInfo,
      amount: Number(doctorInfo?.amount)
    }
    axios.post("https://arogyanxtdevapi.fundaclear.in/api/Doctor", body).then((res) =>{
      if(res?.status === 200){
        // navigate("/opd", { state: { addPatient: false } })
        successToast(res?.data?.message);
      }
    }).catch((err) =>{
      errorToast(err?.response?.data?.error || err?.response?.data?.message)
    })
  }

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
        <DoctorInformation submitDoctorInfo={submitDoctorInfo} />
        </>
      </div>
    </div>
  )
}

export default DoctorContainer